// Cloudflare Turnstile — resolución de site key con fallback preview.
//
// Regla: la site key registrada en el panel de Cloudflare Turnstile está ligada a un
// dominio (o lista de dominios). En el ambiente PREVIEW/DEV el hostname es distinto
// (ej. *.preview.emergentagent.com o localhost) y Cloudflare rechaza el widget con
// "No es posible conectarse al sitio web".
//
// Solución: si el hostname del navegador NO coincide con la lista de dominios PROD
// autorizados (felvora.app y www.felvora.app), usar la site-key de PRUEBAS oficial de
// Cloudflare `1x00000000000000000000AA` (always-passes). Esto permite ver el flujo
// end-to-end en preview sin exponer la key real ni desactivar la protección.
//
// En PRODUCCIÓN el navegador está en felvora.app → usa la key real → protección real.
// El backend valida el token contra Cloudflare con la Secret Key real; si el frontend
// mandó el token de prueba y el backend tiene la secret real, el token de prueba será
// rechazado (así se mantiene la seguridad en prod).

const DOMINIOS_PROD = ["felvora.app", "www.felvora.app"];
const SITE_KEY_TEST_ALWAYS_PASS = "1x00000000000000000000AA";

export function resolveTurnstileSiteKey() {
  const configured = process.env.REACT_APP_TURNSTILE_SITE_KEY || "";
  if (!configured) return SITE_KEY_TEST_ALWAYS_PASS;
  // Si no hay `window` (SSR/tests) → devuelve la configurada, sin heurística.
  if (typeof window === "undefined" || !window.location) return configured;
  const host = window.location.hostname || "";
  return DOMINIOS_PROD.includes(host) ? configured : SITE_KEY_TEST_ALWAYS_PASS;
}
